import { TitleCasePipe } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { Severity } from "../../constants/constants";
import { SetupService } from "../setup.service";
import { PackBoxService } from "./pack-box.service";

@Component({
    selector: "app-pack-box",
    templateUrl: "./pack-box.component.html",
    styleUrls: ["./pack-box.component.scss"],
})
export class PackBoxComponent implements OnInit, OnDestroy {
    addEditParentHeader;
    displayAddEditParent = false;
    addEditChildHeader;
    displayAddEditChild = false;
    allPackBoxes = [];
    parentForm: FormGroup;
    childForm: FormGroup;
    parentDialogType = "ADD";
    childDialogType = "ADD";
    selectedParent;
    selectedChild;
    submittedParent = false;
    submittedChild = false;
    isDuplicacy : boolean= false;

    constructor(
        private packBoxService: PackBoxService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private titlecasePipe: TitleCasePipe,
        private setupService: SetupService,
        private fb: FormBuilder
    ) {}

    ngOnInit(): void {
        this.initForm();
        this.getAllPackBoxList();
        this.setupService.getPackBox().subscribe((a) => {
            if (a) {
                this.showAddPackBox();
            }
        });
    }

    initForm() {
        this.parentForm = this.fb.group({
            id: [0],
            name: ["", Validators.required],
            statusId: [true],
        });

        this.childForm = this.fb.group({
            id: [0],
            name: ["", Validators.required],
            length: [""],
            width: [""],
            height: [""],
            weight: [""],
            statusId: [true],
        });
    }

    getAllPackBoxList() {
        this.packBoxService.getPackBoxListWithHierarchy().subscribe(
            (res) => {
                this.allPackBoxes = res;
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            }
        );
    }

    showAddPackBox() {
        this.addEditParentHeader = "Add Package";
        this.displayAddEditParent = true;
        this.parentDialogType = "ADD";
        this.initForm();
    }

    editParent(parent) {
        this.initForm();
        this.addEditParentHeader = "Edit Package";
        this.displayAddEditParent = true;
        this.parentDialogType = "EDIT";
        this.selectedParent = parent;
        this.parentForm.patchValue({
            ...parent,
            statusId: parent.statusId == 1 ,
        });
    }

    validatePackBoxName(obj) : boolean  {
        if (!obj?.name?.trim()) {
            return false;
        }
        this.isDuplicacy = this.allPackBoxes?.some((ele) => ele.name?.toLowerCase() === obj?.name.toLowerCase() && ele?.id !== obj?.id);
        return this.isDuplicacy; 
      }
    
    saveParent() {
        if(this.validatePackBoxName(this.parentForm.value)){
           return ;
        }
        this.submittedParent = true;
        if (this.parentDialogType == "ADD") {
            const data = {
                id: 0,
                name: this.parentForm.controls.name.value,
                isDefault: false,
                length: 0,
                width: 0,
                height: 0,
                weight: 0,
                statusId: this.parentForm.controls.statusId.value ? 1 : 2,
            };
            this.packBoxService.addPackBox(data).subscribe(
                (res) => {
                    this.displayAddEditParent = false;
                    this.submittedParent = false;
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Saved Successfully...",
                    });
                    this.getAllPackBoxList();
                },
                (error) => {
                    this.displayAddEditParent = false;
                    this.submittedParent = false;
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred while saving data...",
                    });
                }
            );
        } else if (this.parentDialogType == "EDIT") {
            const data = {
                id: this.selectedParent.id,
                name: this.parentForm.controls.name.value,
                isDefault: this.selectedParent.isDefault,
                length: this.selectedParent.length,
                width: this.selectedParent.width,
                height: this.selectedParent.height,
                weight: this.selectedParent.weight,
                statusId: this.parentForm.controls.statusId.value ? 1 : 2,
            };
            this.packBoxService.updatePackBox(data).subscribe(
                (res) => {
                    this.displayAddEditParent = false;
                    this.submittedParent = false;
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Updated Successfully...",
                    });
                    this.getAllPackBoxList();
                },
                (error) => {
                    this.displayAddEditParent = false;
                    this.submittedParent = false;
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred while updating data...",
                    });
                }
            );
        }
    }
    onCancel() {
        this.displayAddEditParent = false;
        this.isDuplicacy = false;
      }
    addChild(parent) {
        this.initForm();
        this.addEditChildHeader = "Add Box";
        this.displayAddEditChild = true;
        this.selectedParent = parent;
        this.childDialogType = "ADD";
    }

    editChild(parent, child) {
        this.initForm();
        this.addEditChildHeader = "Edit Box";
        this.childDialogType = "EDIT";
        this.displayAddEditChild = true;
        this.selectedParent = parent;
        this.selectedChild = child;
        this.childForm.patchValue({
            ...child,
            statusId: child.statusId == 1 ? true : false,
        });
    }

    saveChild() {
        this.submittedChild = true;
        if (this.childDialogType == "ADD") {
            const data = {
                id: 0,
                parentId: this.selectedParent.id,
                name: this.childForm.controls.name.value,
                length: this.childForm.controls.length.value
                    ? this.childForm.controls.length.value
                    : 0,
                width: this.childForm.controls.width.value
                    ? this.childForm.controls.width.value
                    : 0,
                height: this.childForm.controls.height.value
                    ? this.childForm.controls.height.value
                    : 0,
                weight: this.childForm.controls.weight.value
                    ? this.childForm.controls.weight.value
                    : 0,
                statusId: this.childForm.controls.statusId.value ? 1 : 2,
                isDefault: false,
            };
            this.packBoxService.addPackBox(data).subscribe(
                (res) => {
                    this.displayAddEditChild = false;
                    this.submittedChild = false;
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Saved Successfully...",
                    });
                    this.getAllPackBoxList();
                },
                (error) => {
                    this.displayAddEditChild = false;
                    this.submittedChild = false;
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred while Saving data...",
                    });
                }
            );
        } else if (this.childDialogType == "EDIT") {
            const data = {
                id: this.selectedChild.id,
                parentId: this.selectedParent.id,
                name: this.childForm.controls.name.value,
                length: this.childForm.controls.length.value,
                width: this.childForm.controls.width.value,
                height: this.childForm.controls.height.value,
                weight: this.childForm.controls.weight.value,
                statusId: this.childForm.controls.statusId.value ? 1 : 2,
                isDefault: this.selectedChild.isDefault,
            };
            this.packBoxService.updatePackBox(data).subscribe(
                (res) => {
                    this.displayAddEditChild = false;
                    this.submittedChild = false;
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Updated Successfully...",
                    });
                    this.getAllPackBoxList();
                },
                (error) => {
                    this.displayAddEditChild = false;
                    this.submittedChild = false;
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred while updating data...",
                    });
                }
            );
        }
    }

    removeChild(parent, child) {
        this.confirmationService.confirm({
            message: "Do you want to delete this Box?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.packBoxService.deletePackBox(child.id).subscribe(
                    (res) => {
                        if (res) {
                            this.messageService.add({
                                severity: Severity.Success,
                                summary: this.titlecasePipe.transform(
                                    Severity.Success
                                ),
                                detail: "Deleted Successfully...",
                            });
                            this.getAllPackBoxList();
                        }
                    },
                    (error) => {
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(
                                Severity.Error
                            ),
                            detail: "Error occurred while deleting data...",
                        });
                    }
                );
            },
            reject: () => {},
        });
    }

    boxDefault(data) {
        data.isDefault = true;
        this.packBoxService.updatePackBox(data).subscribe((res) => {
            this.getAllPackBoxList();
        });
    }

    ngOnDestroy(): void 
    {
      this.setupService.setPackBox('');
    }
}
